import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
import { ADVANTAGE_CARDS } from "appLauncher";

const Section = styled.section`
  background-image: url(/assets/product/bar-background.png);
  background-position: center;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 49px;
`;

const CardGroup = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 32px;
  justify-content: center;
  flex-wrap: wrap;
`;

const Card = styled.div`
  width: 282px;
  height: 190px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(38, 64, 237, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: default;
  position: relative;
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  &:hover {
    background: #2640ed;
    transform: scale(1.045);
  }
  &:hover img {
    filter: brightness(100);
  }
`;

const CardIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const CardTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #1b2532;
  margin-bottom: 8px;
  transition: color 0.3s;
  ${Card}:hover & {
    color: #fff;
  }
`;

const CardDesc = styled.div`
  font-size: 15px;
  color: #fff;
  opacity: 0;
  max-height: 0;
  margin: 0 24px;
  text-align: center;
  transition: opacity 0.3s, max-height 0.3s;
  ${Card}:hover & {
    opacity: 1;
    max-height: 80px;
    margin-top: 4px;
  }
`;

export default function ServiceAdvantage() {
  return (
    <Section>
      <SectionTitle>服务优势</SectionTitle>
      <SectionSubtitle>Service Advantages</SectionSubtitle>
      <CardGroup>
        {ADVANTAGE_CARDS.map((card, idx) => (
          <Card key={idx}>
            <CardIcon>
              <img src={"/assets/pic/s-" + (idx + 1) + ".png"} />
            </CardIcon>
            <CardTitle>{card.title}</CardTitle>
            <CardDesc>{card.desc}</CardDesc>
          </Card>
        ))}
      </CardGroup>
    </Section>
  );
}
